/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Iso code of a notification language
 * @export
 */
export const NotificationLanguageIsoCodeEnum = {
    Fr: 'FR',
    En: 'EN',
    Es: 'ES',
    De: 'DE'
} as const;
export type NotificationLanguageIsoCodeEnum = typeof NotificationLanguageIsoCodeEnum[keyof typeof NotificationLanguageIsoCodeEnum];


export function instanceOfNotificationLanguageIsoCodeEnum(value: any): boolean {
    for (const key in NotificationLanguageIsoCodeEnum) {
        if (Object.prototype.hasOwnProperty.call(NotificationLanguageIsoCodeEnum, key)) {
            if (NotificationLanguageIsoCodeEnum[key as keyof typeof NotificationLanguageIsoCodeEnum] === value) {
                return true;
            }
        }
    }
    return false;
}

export function NotificationLanguageIsoCodeEnumFromJSON(json: any): NotificationLanguageIsoCodeEnum {
    return NotificationLanguageIsoCodeEnumFromJSONTyped(json, false);
}

export function NotificationLanguageIsoCodeEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationLanguageIsoCodeEnum {
    return json as NotificationLanguageIsoCodeEnum;
}

export function NotificationLanguageIsoCodeEnumToJSON(value?: NotificationLanguageIsoCodeEnum | null): any {
    return value as any;
}

export function NotificationLanguageIsoCodeEnumToJSONTyped(value: any, ignoreDiscriminator: boolean): NotificationLanguageIsoCodeEnum {
    return value as NotificationLanguageIsoCodeEnum;
}

